import { AxiosError } from 'axios'
import { McdViewError } from '~/lib/models/errors'

export const useErrorView = () => {
  const errorView: Ref<AxiosError | McdViewError | Error | undefined> = ref()

  return errorView
}
